import React, {useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';
import '../components/precision/precision.css';
import './palette.css';
import './finesse.css';
import './personality.css';
import './perform.css';
import './finish.css';
import './insights.css';
import './account.css';
export default function MemberDesign({children}: {children: React.ReactNode}) {
 const {pathname}=useLocation();
 useLayoutEffect(()=>{
  document.body.dataset.memberScreen=pathname==='/dashboard'?'home':pathname.startsWith('/training')?'perform':pathname==='/profile'?'profile':pathname==='/leaderboard'?'fame':'app';
  return ()=>{delete document.body.dataset.memberScreen;};
 },[pathname]);
 return <>{children}</>;
}
